;(function($) {
    $.fn.counter = function(options) {
        var settings = $.extend({
            start: 0,
            end: 100,
            decimals: 0,
            easing: 'swing',
            duration: 400,
            thousandsSeparator: '.',
            decimalsSeparator: ',',
			parentSelector: '',
			removeNegativeSign: false,
			onUpdate: function() {},
			onAfterUpdate: function() {}
        }, options);

		if (isNaN(settings.start)) settings.start = 0;
		if (isNaN(settings.end))   settings.end   = 0;

        var $this = $(this);
        var $parent = settings.parentSelector != '' ? $this.closest(settings.parentSelector) : null;

        var getFormattedText = function(count) {
            var showCount = parseFloat(count);

            if (isNaN(showCount)) {
                showCount = 0;
            }

            showCount = showCount.toFixed(settings.decimals);

            var showCountParts = showCount.split('.');
            var number         = showCountParts[0];
            var decimals       = showCountParts[1];

            showCount = number.replace(/\B(?=(\d{3})+(?!\d))/g, settings.thousandsSeparator);

            if (settings.removeNegativeSign) {
            	showCount = showCount.replace('-', '');
			}

            if (decimals != undefined) {
                showCount += '<span class="counter-separator">' + settings.decimalsSeparator +
					'</span><span class="counter-decimals">' + decimals + '</span>';
            }

            return showCount;
        };

        var setValue = function(count) {
        	var formattedText = getFormattedText(count);
			$this.data('counter-current', count).html(formattedText);

			if ($parent) {
				$parent.toggleClass('counter-positive', count > 0);
				$parent.toggleClass('counter-zero', count == 0);
				$parent.toggleClass('counter-negative', count < 0);
			}
		}

        $({count: settings.start}).stop(false, false).animate({count: settings.end}, {
            duration: settings.duration,
            easing: settings.easing,
            step: function() {
            	setValue(this.count);
				settings.onUpdate(this.count);
            },
            complete: function() {
            	setValue(settings.end);
				settings.onAfterUpdate(settings.end);
            }
        });
    };
}(jQuery));
